
	<div class="row">
		<div class="col-lg-5 col-md-6 col-xs-12">
			<alert [alert]="msg"></alert>
			<p>Click a school name to switch the school or click the checkbox to make a default school in the next login.</p>
		</div>
	</div>
	<div class="row">
		<div class="col-lg-5 col-md-6 col-xs-12">
			<div class="card scrollable">
				<table class="table">
					<thead>
						<tr>
							<th>AcctNumber</th>
							<th>Schools</th>
							<th>Is Default</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let row of data; let i = index">
							<td style="width:130px;">{{row.acctNumber}}</td>
							<td style=""><a (click)="changeUserRoles(i)" style="cursor: pointer;">{{row.schoolName}}</a></td>
							<td style="width:80px;">
								<input [(ngModel)]="row.isDefault" type="checkbox" (change)="setDefault(i)" [checked]="row.isDefault" />
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
  